export default __webpack_public_path__ + "88c9318f39f4a8263e12d1ba27ec414b.jpg";